import { render, staticRenderFns } from "./modalEskalasiFppk.vue?vue&type=template&id=0f776114&scoped=true"
import script from "./modalEskalasiFppk.vue?vue&type=script&lang=js"
export * from "./modalEskalasiFppk.vue?vue&type=script&lang=js"
import style0 from "./modalEskalasiFppk.vue?vue&type=style&index=0&id=0f776114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f776114",
  null
  
)

export default component.exports